import { render, staticRenderFns } from "./LocationBlock.vue?vue&type=template&id=0ca8e57f&scoped=true&"
import script from "./LocationBlock.vue?vue&type=script&lang=js&"
export * from "./LocationBlock.vue?vue&type=script&lang=js&"
import style0 from "./LocationBlock.vue?vue&type=style&index=0&id=0ca8e57f&lang=scss&"
import style1 from "./LocationBlock.vue?vue&type=style&index=1&id=0ca8e57f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca8e57f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ca8e57f')) {
      api.createRecord('0ca8e57f', component.options)
    } else {
      api.reload('0ca8e57f', component.options)
    }
    module.hot.accept("./LocationBlock.vue?vue&type=template&id=0ca8e57f&scoped=true&", function () {
      api.rerender('0ca8e57f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/LocationBlock.vue"
export default component.exports